module.exports = __webpack_public_path__ + "img/mango-lassi.ed0564ec.jpg";